import React, { useEffect, useState } from 'react';
import { Button, Container, Header } from 'semantic-ui-react';
import { TextAreaField, TextField, Form } from '@plone/components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EPICS_PATH_CONTINUE } from 'volto-epics-addon/constants';
import { TASK_UPLOAD_BASICINFO_PROMPT } from 'volto-base-addon/constants';
import { completeTask, useTask } from 'volto-epics-addon/helpers';
import UploadStepsContainer from 'volto-base-addon/components/theme/FileUpload/UploadStepsContainer';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  basicInfoHeader: {
    id: 'basicInfoHeader',
    defaultMessage: 'Basic info',
  },
  titleLabel: {
    id: 'titleLabel',
    defaultMessage: 'Title',
  },
  descriptionLabel: {
    id: 'descriptionLabel',
    defaultMessage: 'Description',
  },
  submitButton: {
    id: 'submitButton',
    defaultMessage: 'Submit',
  },
  alertMustSetTitle: {
    id: 'alertMustSetTitle',
    defaultMessage: 'You must set a title.',
  },
  alertMustSetDescription: {
    id: 'alertMustSetDescription',
    defaultMessage: 'You must set a description.',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const history = useHistory();
  const intl = useIntl();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const task = useTask(TASK_UPLOAD_BASICINFO_PROMPT);
  const token = useSelector((state) => state.userSession.token);
  const filename = task?.variables?.filename;
  const destinationTitle = task?.variables?.destinationTitle;

  useEffect(() => {
    setIsAuthenticated(!!token);
    setIsVisible(true);
  }, [token]);

  useEffect(() => {
    if (task?.completed === true) {
      history.push(EPICS_PATH_CONTINUE);
    }
  }, [task, history]);

  const onSubmit = async (ev) => {
    if (!token) return;

    ev.nativeEvent.preventDefault();

    try {
      if (!title) {
        // eslint-disable-next-line no-alert
        alert(intl.formatMessage(messages.alertMustSetTitle));
        return;
      }
      if (!description) {
        // eslint-disable-next-line no-alert
        alert(intl.formatMessage(messages.alertMustSetDescription));
        return;
      }
      completeTask(TASK_UPLOAD_BASICINFO_PROMPT, {
        title: title,
        description: description,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  return isVisible ? (
    isAuthenticated ? (
      <Container className="basicinfo-prompt-container">
        <UploadStepsContainer currentStep={2} totalSteps={4} />
        <Header> {intl.formatMessage(messages.basicInfoHeader)} </Header>
        {destinationTitle && filename ? (
          <p>
            {destinationTitle} / {filename}
          </p>
        ) : null}
        <Form onSubmit={onSubmit}>
          <TextField
            onChange={(value) => setTitle(value)}
            label={intl.formatMessage(messages.titleLabel)}
            isRequired
          ></TextField>
          <TextAreaField
            label={intl.formatMessage(messages.descriptionLabel)}
            onChange={(value) => setDescription(value)}
            value={description}
          ></TextAreaField>
          <Button style={{ marginTop: '1em' }} floated="right" type="submit">
            {intl.formatMessage(messages.submitButton)}
          </Button>
        </Form>
      </Container>
    ) : (
      <Container className="basicinfo-prompt-container">
        <Header className="ui header">
          {' '}
          {intl.formatMessage(messages.mustLoginFirst)}{' '}
        </Header>
      </Container>
    )
  ) : (
    <Container className="basicinfo-prompt-container"></Container>
  );
};

export default Page;
